import React, { useEffect, useState } from "react";
import { FormLabel, Stack, TextField } from "@mui/material";

const ColorPicker = ({ label, themeColors, colorKey, setThemeColors }) => {
  const [color, setColor] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setColor(e.target.value);
    setThemeColors((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setColor(themeColors?.[colorKey]);
  }, [colorKey, themeColors]);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <FormLabel style={{ textAlign: "start" }}>{label}</FormLabel>
      <TextField
        type="color"
        name={colorKey}
        className="theme-color-picker"
        value={color}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: 52 }}
      />
    </Stack>
  );
};

export default ColorPicker;
